import React, { Component } from 'react';
import { MasterLayoutProps } from '../connected/MasterLayoutCnn';
import LayoutCnn from '../connected/LoggedInLayoutCnn';
import PublicLayoutCnn from '../connected/PublicLayoutCnn';
import { withRouter } from 'react-router';
import * as firebase from 'firebase/app'

const publicPaths = ["/Login", "/SignUp", "/ResetPassword", "/Action"]

class MasterLayout extends Component<MasterLayoutProps> {
    constructor(props: MasterLayoutProps) {
        super(props)
        firebase.auth().onAuthStateChanged((user) => {
            if(this.props.signUpBusy === false)
                this.props.onFirebaseAuthChange(user !== null)
        });
    }

    componentDidUpdate(prevProps: MasterLayoutProps){
        if(this.areWeOnPublicPath() === false && prevProps.isAuthenticated !== false && this.props.isAuthenticated === false)
            this.props.history.push('/Login')
    }

    areWeOnPublicPath = () => {
        return publicPaths.find((p) => p === this.props.history.location.pathname) !== undefined
    }

    render() {
        return (
            <div>
                {this.props.isAuthenticated !== null &&
                    <div>
                        {this.props.isAuthenticated === true && this.areWeOnPublicPath() === false ?
                            <LayoutCnn {...this.props}>
                                {this.props.children}
                            </LayoutCnn>
                            :
                            <PublicLayoutCnn>
                                {this.props.children}
                            </PublicLayoutCnn>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(MasterLayout);